import { render, staticRenderFns } from "./auto-layout.vue?vue&type=template&id=15de1ba0"
import script from "./auto-layout.vue?vue&type=script&lang=js"
export * from "./auto-layout.vue?vue&type=script&lang=js"
import style0 from "./auto-layout.vue?vue&type=style&index=0&id=15de1ba0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports